import { createSelector } from "reselect";
import _ from "underscore";

import getElementDetailsByGlobalId from "../get_element_details_by_global_id";
import getPlannedElementsByGlobalId from "../get_planned_elements_by_global_id";
import getSelectedElementGlobalIds from "./get_selected_element_global_ids";
import PlannedBuildingElement from "../../../../models/domain/planned_building_element";

const empty: PlannedBuildingElement[] = [];
const getSelectedElements = createSelector([
  getSelectedElementGlobalIds,
  getPlannedElementsByGlobalId,
  getElementDetailsByGlobalId
], (selectedGlobalIds, elementsByGlobalId, detailsByGlobalId) => {
  if (selectedGlobalIds.length) {
    return _.compact(selectedGlobalIds.map(globalId => {
      const element = elementsByGlobalId?.[globalId];
      return element && PlannedBuildingElement.withDetails(element, detailsByGlobalId[globalId]);
    }));
  } else {
    return empty;
  }
});

export default getSelectedElements;
